import React from 'react';
import Container from '../container';
import styled from 'styled-components';
import CtaWithArrow from '../cta-with-arrow';
import LazyImage from '../lazy-image';
import { getFluidGatsbyImage } from '../../utils/gatsby-storyblok-image-fixed';

const OuterContainer = styled.div`
  background: var(--Background-bg-inverse, #161616);
  padding: 96px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 876px) {
    padding: 48px 0px;
  }
`;

const ContentContainerInner = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 20px;
  @media (max-width: 876px) {
    display: flex;
    flex-direction: column;
    gap: 48px;
  }
`;

const LeftContent = styled.div`
  grid-column: 1 / span 5;
`;

const Title = styled.h1`
  color: #fff;
  font-size: 52px;
  font-style: normal;
  font-weight: 700;
  line-height: 110%;
  letter-spacing: -1.04px;
  margin-bottom: 24px;
  @media (max-width: 876px) {
    font-size: 36px;
    letter-spacing: -0.5px;
  }
`;

const LabelContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
`;

const Label = styled.span`
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: -0.28px;
`;

const LabelDecoration = styled.div`
  width: 16px;
  height: 2px;
  background: #813dff;
`;

const Description = styled.p`
  color: #f6f6f6;
  font-size: 18px;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.36px;
  max-width: 440px;
  margin-bottom: 24px;
`;

const RightContent = styled.div`
  grid-column: 7 / span 6;
  aspect-ratio: 1/1;
`;

const StatsSection = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 100%;
  margin-bottom: 36px;
  @media (max-width: 456px) {
    grid-template-columns: 1fr;
  }
`;

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const StatLabel = styled.span`
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.32px;
`;

const StatValue = styled.span`
  color: #c4c4c4;
  font-size: 16px;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.32px;
`;

export default function CaseStudyBrowserHero({
  label,
  featuredCaseStudy
}: {
  label: string;
  featuredCaseStudy: any;
}) {
  return (
    <OuterContainer>
      <Container>
        <ContentContainerInner>
          <LeftContent>
            <LabelContainer>
              <Label>{label}</Label>
              <LabelDecoration />
            </LabelContainer>
            <Title>{featuredCaseStudy.content.title}</Title>
            <Description>
              {featuredCaseStudy.content.about[0]?.infoParagraph}
            </Description>
            <StatsSection>
              {featuredCaseStudy.content.about[0].projectStats.map(
                (stat: any) => (
                  <Stat key={stat.name}>
                    <StatLabel>{stat.name}</StatLabel>
                    <StatValue>{stat.value}</StatValue>
                  </Stat>
                )
              )}
            </StatsSection>
            <CtaWithArrow
              label="View Case Study"
              link={`/${featuredCaseStudy.full_slug}`}
              darkTheme
            />
          </LeftContent>
          <RightContent>
            <LazyImage
              width="100%"
              height="100%"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: 'var(--Radius-Radius-3, 16px)',
                overflow: 'hidden'
              }}
              fluid={getFluidGatsbyImage(featuredCaseStudy?.content?.gridImage)}
              alt={featuredCaseStudy?.content?.gridImage?.alt}
            />
          </RightContent>
        </ContentContainerInner>
      </Container>
    </OuterContainer>
  );
}
